import { render } from "./blogsidebar.vue?vue&type=template&id=2dbf77d1"
import script from "./blogsidebar.vue?vue&type=script&lang=js"
export * from "./blogsidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__